import { sanitizeFileName } from "@epcnetwork/core-ui-kit";

import { csvFormat, txtFormat } from "constants/file.constants";
import { SumClicksFileData } from "./sum-clicks.types";

export const supportedFormats = [csvFormat, txtFormat].flat();
export const getInitialData = (item: File): SumClicksFileData => ({
  fileName: sanitizeFileName(item.name),
});
